import { connect } from 'react-redux'
import { actions } from '@opallabs/wormhole'
import { TrackedFilterBar } from '.'

const FilterBarComponent = (props) => <TrackedFilterBar {...props} />

const mapStateToProps = (state, ownProps) => ({
  disabledValues: ownProps.disabledValues || state.disabledValues,
  filterTree: ownProps.filterTree || state.filterTree,
  filterValues: ownProps.filterValues || state.filterValues,
  servicesLoaded: state.servicesLoaded,
  value: ownProps.value || state.value,
  filtersDisabled: state.filters.filtersDisabled || false,
})

const mapDispatchToProps = (dispatch) => ({
  loadFilters: (params) => {
    const enabledFilters = params.rawValue.filter(
      (filter) => !params.disabledValues.includes(filter.id)
    )

    // loads the entire 'filter' object into redux. This
    // includes the entire filter tree that exists in
    // the filter bar, selected filters, and filters that
    // have been toggeled off. 'filterIdsByType' and
    // 'hasActiveFilters' were added to interface with
    // Week View.
    dispatch(
      actions.loadFilters({
        filterTree: params.filterTree,
        value: params.value,
        disabledValues: params.disabledValues,
        filterValues: params.filterValues,
        hasActiveFilters: !!enabledFilters.length,
        selectedFilters: params.selectedFilters,
      })
    )
  },
  toggleFilters: () => {
    dispatch(actions.toggleFilters())
  },
})

const ConnectedFilterBar = connect(
  mapStateToProps,
  mapDispatchToProps
)(FilterBarComponent)

export default ConnectedFilterBar
